import compact from 'lodash/compact';
import { requestAccountantAccessModel } from "../../models/request-accountant-access";
import { relationshipModel } from "../../models";
export let COBStep;

(function (COBStep) {
  COBStep["welcome"] = "welcome";
  COBStep["selectAPackage"] = "packages";
  COBStep["reviewServices"] = "services";
  COBStep["approveTerms"] = "terms";
  COBStep["accountantAccess"] = "accountant-access";
  COBStep["paymentMethod"] = "payment-method";
  COBStep["summary"] = "summary";
  COBStep["allSet"] = "all-set";
})(COBStep || (COBStep = {}));

export function getStepName(step, relationship, COB_IMPROVEMENTS) {
  switch (step) {
    case COBStep.welcome:
      return COB_IMPROVEMENTS ? 'Introduction' : "Welcome ".concat(relationship.buyer.firstName);

    case COBStep.selectAPackage:
      return 'Select a Package';

    case COBStep.reviewServices:
      return relationshipModel.isInvite(relationship) ? 'Review Billing Details' : 'Review Services';

    case COBStep.approveTerms:
      return 'Review Terms';

    case COBStep.accountantAccess:
      return 'Grant Accountant Access';

    case COBStep.paymentMethod:
      return 'Add a Payment Method';

    case COBStep.summary:
      return COB_IMPROVEMENTS ? 'Sign' : relationshipModel.isInvite(relationship) ? 'Approve Payments' : 'Sign & Approve';

    case COBStep.allSet:
      return "You're all set!";
  }
}
export function getReachableSteps(relationship, accountants, COB_IMPROVEMENTS) {
  const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
  const hasPackages = !!relationship.serviceBundles;
  const accountantAccessRequested = requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && accountants.every(a => a.id !== relationship.vendor.id);
  return compact([COBStep.welcome, hasPackages && COBStep.selectAPackage, COBStep.reviewServices, COBStep.approveTerms, accountantAccessRequested && !COB_IMPROVEMENTS && COBStep.accountantAccess, hasPaymentMethod && COBStep.paymentMethod, !COB_IMPROVEMENTS && COBStep.summary, COBStep.allSet]);
}
export const reasonToText = {
  [COBStep.paymentMethod]: 'Please add a payment method',
  [COBStep.reviewServices]: 'It is required to select at least one service',
  [COBStep.selectAPackage]: 'Please select a package'
};